module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedExtraBold.9e07ff3.eot";